import React,{useState} from 'react'
import "./style.css";
import List from "./List";
import { status } from "./constant";

function CustomFilter({result,Segments,handleCheckBox}) {
    const setStatus = (root, status) => {
        root.status = status;
        if (Array.isArray(root.items)&& root?.items?.length>0) {
            return root.items.forEach((item) => {
                setStatus(item, status);
            });
        }
    };
    
    const computeStatus = (items) => {
        let checked = 0;
        let indeterminate = 0;
    
        items.forEach((item) => {
            if (item.status && item.status === status.checked) checked++;
            if (item.status && item.status === status.indeterminate) indeterminate++;
        });
    
        if (checked === items.length) {
            return status.checked;
        } else if (checked > 0 || indeterminate > 0) {
            return status.indeterminate;
        }
    };
    
    // Depth-first traversal
    const traverse = (root, needle, status) => {
        let id;
        let items;
    
        if (Array.isArray(root) && root.length>0) {
            items = root;
        } else {
            id = root.id;
            items = root.items;
        }

        if (id === needle) {
            return setStatus(root, status);
        }
    
        if (!items) {
            return root;
        } else {
            items.forEach((item) => traverse(item, needle, status));
            root.status = computeStatus(items);
        }
    };
    
    const [items, setItems] = useState(result);
    const compute = (checkboxId, status) => {
        traverse(items, checkboxId, status);
        setItems(items.slice());
    };
    return (
        <div>
            <List 
                items={items} 
                compute={compute} 
                Segments={Segments} 
                handleCheckBox={handleCheckBox}/>
        </div>
    )
}

export default CustomFilter





